// Вход и сессия — tech/03 §2, tech/08 §2–§3. Прототип: вход по initData, refresh, logout.
import { z } from 'zod';
import { Empty, strict } from '../common.js';
import { endpoint } from '../endpoint.js';
import { DocRef, PlayerBrief } from './models.js';
import { Bootstrap } from './player.js';

/** sessionKey — base64url 32 байт (Р-04); живёт только в памяти клиента (08 §3). */
const SessionKey = z.string().regex(/^[A-Za-z0-9_-]{43}$/);
/** refresh — 32 случайных байта, base64url (08 §3). */
const RefreshToken = z.string().regex(/^[A-Za-z0-9_-]{43}$/);

export const TokenPair = strict({
  accessToken: z.string().min(16),
  refreshToken: RefreshToken,
  sessionKey: SessionKey,
  /** Срок access в секундах (15 мин, 08 §3). */
  expiresIn: z.int().positive(),
});

export const AuthTelegramBody = strict({
  /** Сырая строка Telegram.WebApp.initData, ≤ 4096 байт (08 §2 шаг 1). */
  initData: z.string().min(1).max(4096),
  /** Без размеров экрана — Т-К-19. */
  device: strict({ platform: z.string().min(1).max(32), tgVersion: z.string().min(1).max(16) }),
});

export const AuthTelegramResponse = TokenPair.extend({
  player: PlayerBrief,
  isNew: z.boolean(),
  consentsRequired: z.array(DocRef),
  bootstrap: Bootstrap.optional(),
});

export const authTelegram = endpoint({
  id: 'auth.telegram', method: 'POST', path: '/auth/telegram', auth: false, signed: false,
  idempotency: 'none', rate: 'auth', body: AuthTelegramBody, response: AuthTelegramResponse, status: 200,
  errors: ['INIT_DATA_INVALID', 'INIT_DATA_EXPIRED', 'BANNED'],
  spec: 'tech/03 §2; tech/08 §2', task: 'E02-T01',
});

export const authRefresh = endpoint({
  id: 'auth.refresh', method: 'POST', path: '/auth/refresh', auth: false, signed: false,
  idempotency: 'natural', rate: 'auth', body: strict({ refreshToken: RefreshToken }), response: TokenPair, status: 200,
  errors: ['REFRESH_REUSED'],
  spec: 'tech/03 §2; tech/08 §3', task: 'E02-T01',
});

export const authLogout = endpoint({
  id: 'auth.logout', method: 'POST', path: '/auth/logout', auth: true, signed: true,
  idempotency: 'state', rate: 'write', body: Empty, response: strict({ ok: z.literal(true) }), status: 200,
  errors: [],
  spec: 'tech/03 §2', task: 'E02-T01',
});
